import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { AtendimentoPadraoForm } from '../components/AtendimentoPadraoForm';
import * as service from './atendimentos_acolhimento.service';
export var AtendimentosAcolhimnetoEditar = function () {
    return (_jsx(AtendimentoPadraoForm, { pagina: PAGINAS.ATENDIMENTOS_ACOLHIMENTO, pagina_chave: FUNCIONALIDADES.ATENDIMENTOS_ACOLHIMENTO, rota: ROUTES.ATENDIMENTOS_ACOLHIMENTO, services: service, bloquearCamposNaAlteracao: true }));
};
export default AtendimentosAcolhimnetoEditar;
